<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Rol de Pago de Recaudador {{ numero_documento }}</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-show="!consultaRealizada" type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button v-show="consultaRealizada && imprimir_rol_recaudacion_pdf && id !== ''" type="button" @click="imprimirPdf" class="btn-primary">
            <i class="fa fa-file-pdf-o"></i><span>Imprimir en PDF</span>
          </button>
          <button v-show="consultaRealizada && imprimir_rol_recaudacion_excel && id !== ''" type="button" @click="imprimirExcel" class="btn-secondary">
            <i class="fa fa-file-excel-o"></i><span>Imprimir en Excel</span>
          </button>
          <button v-show="consultaRealizada && puedeGuardar" type="button" @click="cerrar" class="btn-success">
            <i class="fa fa-check"></i><span>Guardar Rol</span>
          </button>
          <button v-show="consultaRealizada" type="button" @click="cancelar" class="btn-danger">
            <i class="fa fa-ban"></i><span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de Recaudador</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2" :class="{
              'select2--disabled': bodegas.length == 1
            }">
              <div class="select2-field">
                <v-select @input="inputSucursal" v-model="selectedBodega" :options="bodegas" label="descripcion" placeholder="Seleccione..."></v-select>
                <label for="bodega">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2" :class="{
              'select2--disabled' : consultaRealizada
            }">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="supervisor_id"
                  v-model="selectedRecaudador"
                  :options="recaudadores"
                  @input="inputRecaudador"
                  @search="searchRecaudadores"
                  label="nombre"
                ></v-select>
                <label for="supervisor_id">Recaudador</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  :disabled="consultaRealizada"
                  v-model="form.desde"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta"
                  :disabled="consultaRealizada"
                  v-model="form.hasta"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="consultaRealizada" class="card">
      <div class="card__title">
        <h5>Rol</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Inicial</th>
                    <th>Nuevas (15 días)</th>
                    <th>Activas</th>
                    <th v-for="porc in porcentajesTarjeta" :key="porc">
                      {{ porc }} %
                    </th>
                    <th>Zona</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ form.inicial_tarjetas }}
                    </td>
                    <td>
                      <div class="form-field">
                        <input-field vMoney :format="int" @input="calcularTotales(true, true)" :readonly="!editar_15_dias_rol || !puedeGuardar" placeholder="# Tarjetas" v-model="form.tarjetas_nuevas" id="tarjetas_nuevas"></input-field>
                      </div>
                    </td>
                    <td>
                      {{ form.tarjetas_activas }}
                    </td>
                    <td v-for="porc in porcentajesTarjeta" :key="porc">
                      <button :disabled="!puedeGuardar" type="button" @click="seleccionarPorcentaje(porc)" class="btn-info btn--text">
                        {{ calcularPorcRecaudacion(parseFloat(porc)) }}
                      </button>
                    </td>
                    <td>
                      <strong>{{ descripcion_ruta }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Días</th>
                    <th v-for="registro in registros" :key="registro.fecha">
                      {{ registro.nombre_dia }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Cobradas</th>
                    <td v-for="registro in registros" :key="registro.fecha + 'cobradas'">
                      {{ registro.cobradas }}
                    </td>
                    <td>
                      {{ form.tarjetas_cobradas }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Devoluciones</th>
                    <td v-for="registro in registros" :key="registro.fecha + 'devoluciones'">
                      {{ registro.devoluciones }}
                    </td>
                    <td>
                      {{ form.devoluciones_completas }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Valor recaudado</th>
                    <td v-for="registro in registros" :key="registro.fecha + 'valor_recaudado'">
                      {{ moneyFormat(registro.valor_recaudado) }}
                    </td>
                    <td>
                      {{ moneyFormat(form.valor_recaudado) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Activas</th>
                    <th>Tipo de supervisión</th>
                    <th>Supervisadas</th>
                    <th v-show="form.tipo_supervision === 'P'">Tarj. Supervisadas</th>
                    <th>Dev. Completa</th>
                    <th>Tot. Activas</th>
                    <th>Cobradas</th>
                    <th>No Cobradas</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ form.tarjetas_activas }}
                    </td>
                    <td>
                      <div class="form-field select">
                        <div class="select-field">
                          <select @change="inputTipoSupervision" v-model="form.tipo_supervision" :disabled="!editar_supervision_rol || !puedeGuardar" name="tipo_supervision" id="tipo_supervision">
                            <option value="P">Porcentaje</option>
                            <option value="U">Unidades</option>
                          </select>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-field">
                        <input-field @input="inputValorSupervision" id="tarjetas_supervisadas" vMoney :format="form.tipo_supervision === 'P'?porcentaje:int" :readonly="!editar_supervision_rol || !puedeGuardar" v-model="form.valor_supervision" placeholder="# Tarjetas"></input-field>
                      </div>
                    </td>
                    <td v-show="form.tipo_supervision === 'P'">
                      {{ form.tarjetas_supervisadas }}
                    </td>
                    <td>
                      {{ form.devoluciones_completas }}
                    </td>
                    <td>
                      {{ form.total_activas }}
                    </td>
                    <td>
                      {{ form.tarjetas_cobradas }}
                    </td>
                    <td>
                      {{ form.tarjetas_no_cobradas }}
                    </td>
                    <td>
                      <strong>{{ form.porcentaje_cobro }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <p>
              <strong>Deuda total: {{ moneyFormat(deuda_recaudador) }}</strong>
            </p>
            <br>
            <div style="max-height: 300px" class="card__content">
              <div class="table-responsive">
                <table class="custom-table">
                  <thead>
                    <tr>
                      <th>Tipo de descuento</th>
                      <th>Fecha</th>
                      <th>Día</th>
                      <th>Detalle</th>
                      <th>Valor</th>
                      <th>Saldo</th>
                      <th>Valor seleccionado</th>
                      <th>
                        <button
                          v-show="puedeGuardar"
                          @click="agregarMovimientos"
                          tooltip="Agregar venta"
                          class="btn-success"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-show="coincideMovimientos(movimiento)"
                      :class="{ 'tr--canceled': movimiento.valor < 0 }"
                      v-for="(movimiento, index) in form.movimientos"
                      :key="movimiento.id"
                    >
                      <td>
                        {{ movimiento.descripcion_tipo_movimiento }}
                      </td>
                      <td>
                        {{ movimiento.fecha }}
                      </td>
                      <td>
                        {{ movimiento.nombre_dia }}
                      </td>
                      <td>
                        {{ movimiento.detalle }}
                      </td>
                      <td>
                        {{ moneyFormat(movimiento.valor) }}
                      </td>
                      <td>
                        {{ moneyFormat(movimiento.saldo) }}
                      </td>
                      <td>
                        {{ moneyFormat(movimiento.valor_pago) }}
                      </td>
                      <td>
                        <button
                          v-show="puedeGuardar"
                          @click="quitarMovimiento(index)"
                          tooltip="Quitar"
                          class="btn-danger btn--text"
                        >
                          <i class="fa fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="6" scope="row">Totales</th>
                      <td colspan="2">
                        {{
                          moneyFormat(
                            lodash.sumBy(form.movimientos, function (o) {
                              return parseFloat(o.valor_pago);
                            })
                          )
                        }}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="consultaRealizada" class="card mt-2">
      <div class="card__title">
        <h5>Totales</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>% Tarj.</th>
                    <th>Pago</th>
                    <th>Descuentos +/-</th>
                    <th>Líquido a recibir</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="form-field select">
                        <div class="select-field">
                          <select
                            v-model="form.porcentaje_recaudador"
                            name="porcentaje_recaudador"
                            id="porcentaje_recaudador"
                            @change="inputPorcRecaudador"
                            :disabled="!puedeGuardar"
                          >
                            <option disabled value="">Seleccione...</option>
                            <option
                              :value="parseFloat(porcentaje)"
                              v-for="porcentaje in porcentajesTarjeta"
                              :key="porcentaje"
                            >
                              {{ porcentaje }} %
                            </option>
                          </select>
                        </div>
                      </div>
                    </td>
                    <td>
                      {{ moneyFormat(form.valor_pago) }}
                    </td>
                    <td>
                      {{ moneyFormat(form.total_movimientos) }}
                    </td>
                    <td>
                      <strong>{{ moneyFormat(form.liquido_recibir) }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :clickToClose="false"
      name="tableSelectMov"
      height="auto"
      width="70%"
      scrollable
      resizable
      adaptive
      reset
    >
      <k-table-select
        v-model="form.movimientos"
        :columnas="[
          {
            nombre: 'tipo_movimiento.descripcion',
            descripcion: 'Tipo de movimiento',
          },
          {
            nombre: 'fecha',
            descripcion: 'Fecha',
            sortable: true,
          },
          {
            nombre: 'nombre_dia',
            descripcion: 'Día',
            sortable: true,
          },
          {
            nombre: 'detalle',
            descripcion: 'Detalle',
            sortable: true,
          },
          {
            nombre: 'valor',
            descripcion: 'Valor',
            money: true,
            sortable: true,
          },
          {
            nombre: 'saldo',
            descripcion: 'Saldo',
            money: true,
            sortable: true,
          },
          {
            nombre: 'valor_pago',
            descripcion: 'Valor seleccionado',
            money: true,
            sortable: true,
          },
        ]"
        saldoSeleccionable
        :params="{
          persona_id: form.recaudador_id,
          rol_recaudador_id: id
        }"
        @cerrar="cerrarMovimientos"
        :urlConsulta="url + '/movimientos-nomina-supervisor'"
        title="Seleccione uno o varios movimientos"
        ref="kTableSelectMov"
        @seleccionar="seleccionarMovimientos"
      ></k-table-select>
    </modal>
  </div>
</template>

<script>
import KTableSelect from "../general/KTableSelect.vue";
export default {
  computed: {
    puedeGuardar: function () {
      return ((this.id == '' && this.crear_rol_recaudacion) || (this.id != '' && this.editar_rol_recaudacion));
    }
  },
  components: {
    KTableSelect,
  },
  props: {
    imprimir_rol_recaudacion_pdf: {
      type: Boolean,
      required: false,
      default: false
    },
    imprimir_rol_recaudacion_excel: {
      type: Boolean,
      required: false,
      default: false
    },
    bodegas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    porc_supervision: {
      type: Number,
      required: false,
      default: 10
    },
    porc_tarjetas: {
      type: String,
      required: true,
    },
    editar_15_dias_rol: {
      type: Boolean,
      required: false,
      default: false
    },
    editar_supervision_rol: {
      type: Boolean,
      required: false,
      default: false
    },
    crear_rol_recaudacion: {
      type: Boolean,
      required: false,
      default: false
    },
    editar_rol_recaudacion: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    inputSucursal: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else 
        this.form.bodega_id = '';
    },
    inputValorSupervision: function () {
      this.calcularTotales(true, true, true);
    },
    inputTipoSupervision: function () {
      this.calcularTotales(true, true);
    },
    inputPorcRecaudador: function () {
      this.form.valor_pago = this.calcularPorcRecaudacion(parseFloat(this.form.porcentaje_recaudador));
      this.calcularTotales(true, true);
    },
    seleccionarPorcentaje: function (porc) {
      this.form.porcentaje_recaudador = porc;
      this.form.valor_pago = this.calcularPorcRecaudacion(porc);
      this.calcularTotales(true, true);
    },
    calcularPorcRecaudacion: function (porc) {
      let valorRecaudacion = parseFloat(this.form.valor_recaudado);
      let res = round(valorRecaudacion * (parseFloat(porc) / 100), 2);
      return res;
    },
    seleccionarMovimientos: function (movimientos) {
      let total = 0;
      this.form.movimientos.splice(0, this.form.movimientos.length);
      for (let i = 0; i < movimientos.length; i++) {
        let valor = movimientos[i].valor *
            (movimientos[i].tipo_movimiento.tipo == "I" ? 1 : -1);
        let valorPago = movimientos[i].valor_pago *
            (movimientos[i].tipo_movimiento.tipo == "I" ? 1 : -1);
        total += valorPago;
        this.form.movimientos.push({
          id: movimientos[i].id,
          descripcion_tipo_movimiento:
            movimientos[i].tipo_movimiento.descripcion,
          detalle: movimientos[i].detalle,
          fecha: movimientos[i].fecha,
          valor: valor,
          nombre_dia: movimientos[i].nombre_dia,
          saldo: movimientos[i].saldo,
          valor_pago: valorPago
        });
      }
      total = round(total, 2);
      this.form.total_movimientos = total;
      this.calcularTotales(true, true);
      this.$modal.hide("tableSelectMov");
    },
    quitarMovimiento: function (index) {
      this.form.movimientos.splice(index, 1);
    },
    coincideMovimientos: function (movimiento) {
      let busqueda = this.searchMovimientos.toUpperCase();
      if (busqueda != "") {
        return (
          movimiento.detalle.toUpperCase().includes(busqueda) ||
          movimiento.descripcion_tipo_movimiento
            .toUpperCase()
            .includes(busqueda) ||
          movimiento.fecha.includes(busqueda) ||
          movimiento.valor.toString().includes(busqueda)
        );
      } else return true;
    },
    agregarMovimientos: function () {
      this.$modal.show("tableSelectMov");
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?bodega_id=" + this.form.bodega_id + "&tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    calcularTotales: function (edicionNuevas = false, edicionSupervision = false, supervisionTecleada = false) {
      this.form.inicial_tarjetas = this.tarjetas.length;
      this.form.valor_recaudado = _.sumBy(this.registros, function (o) {
        return parseFloat(o.valor_recaudado);
      });
      if (!edicionNuevas) {
        let nuevas = _.filter(this.tarjetas, (o) => {
          return o.es_nueva;
        });
        this.form.tarjetas_nuevas = nuevas.length;
        let cobradas = _.filter(this.tarjetas, (o) => {
          return o.tiene_recaudacion;
        });
        this.form.tarjetas_cobradas = cobradas.length;
      }
      let tarjNuevas = parseInt(this.form.tarjetas_nuevas);
      if (tarjNuevas > this.form.inicial_tarjetas) {
        this.form.tarjetas_nuevas = 0;
      }
      if (isNaN(tarjNuevas))
        tarjNuevas = 0;
      this.form.tarjetas_activas = this.form.inicial_tarjetas - tarjNuevas;
      if (!edicionSupervision)
      {
        this.form.tarjetas_supervisadas = Math.round(this.form.tarjetas_activas * (
          this.porc_supervision / 100
        ));
        this.form.valor_supervision = this.form.tarjetas_supervisadas;
        this.form.tipo_supervision = 'U';
      }
      else {
        if (this.form.tipo_supervision === 'U') {
          if (!supervisionTecleada) {
            this.form.tarjetas_supervisadas = Math.round(this.form.tarjetas_activas * (
              this.porc_supervision / 100
            ));
            this.form.valor_supervision = this.form.tarjetas_supervisadas;
          }
          else 
            this.form.tarjetas_supervisadas = this.form.valor_supervision;
        }
        else 
        {
          let valorSupervision = parseFloat(this.form.valor_supervision);
          if (isNaN(valorSupervision))
            valorSupervision = 0;
          if (valorSupervision > 100) {
            this.form.tarjetas_supervisadas = 0;
            this.form.valor_supervision = 0;
          }
          else {
            this.form.tarjetas_supervisadas = Math.round(this.form.tarjetas_activas * (
              valorSupervision / 100
            ));
          }
        }
      }
      this.form.total_activas = this.form.tarjetas_activas - this.form.tarjetas_supervisadas;

      this.form.tarjetas_no_cobradas = this.form.total_activas - this.form.tarjetas_cobradas;
      if (this.form.total_activas > 0)
        this.form.porcentaje_cobro = round((this.form.tarjetas_cobradas / this.form.total_activas) * 100, 2);
      else 
        this.form.porcentaje_cobro = 0;
      this.form.liquido_recibir = round(parseFloat(this.form.valor_pago) + this.form.total_movimientos, 2);
    },
    consultar: function () {
      let desde = moment(this.form.desde);
      let hasta = moment(this.form.hasta);
      if (hasta.diff(desde, 'days') > 7) {
        swal('No se permite consultas mayores a una semana.', 'Aviso', 'warning');
        return;
      }
      axios.get(url + 'rol-recaudador', {
        params: this.form
      }).then(({data}) => {
        this.deuda_recaudador = data.deuda_recaudador;
        this.registros = data.registros;
        this.tarjetas = data.tarjetas;
        this.descripcion_ruta = data.ruta.nombre;
        this.form.movimientos.splice(0, this.form.movimientos.length);
        if (data.rolExistente != null) {
          this.id = data.rolExistente.id;
          this.numero_documento = data.rolExistente.numero_documento;
          this.form.tarjetas_nuevas = data.rolExistente.tarjetas_nuevas;
          this.form.tipo_supervision = data.rolExistente.tipo_supervision;
          this.form.tarjetas_supervisadas = data.rolExistente.tarjetas_supervisadas;
          this.form.porcentaje_recaudador = parseFloat(data.rolExistente.porcentaje_recaudador);
          this.form.valor_pago = data.rolExistente.valor_pago;
          this.form.valor_supervision = data.rolExistente.valor_supervision;
          let total = 0;
          for (let i = 0; i < data.rolExistente.cancelaciones.length; i++) {
            let mov = data.rolExistente.cancelaciones[i].movimiento == null?data.rolExistente.cancelaciones[i].movimiento_caja:data.rolExistente.cancelaciones[i].movimiento;
            let canc = data.rolExistente.cancelaciones[i];
            let multiplicador = mov.tipo_movimiento.tipo === 'I'?1:-1;
            let valorPago = parseFloat(canc.valor_pago) * multiplicador;
            let valor = parseFloat(mov.valor) * multiplicador;
            this.form.movimientos.push({
              id: mov.id,
              descripcion_tipo_movimiento:
                mov.tipo_movimiento.descripcion,
              detalle: mov.detalle,
              fecha: mov.fecha,
              valor: valor,
              nombre_dia: data.rolExistente.cancelaciones[i].movimiento.descripcion_dia,
              saldo: round(parseFloat(data.rolExistente.cancelaciones[i].movimiento.saldo), 2),
              valor_pago: valorPago
            });
            total+= valorPago;
          }
          total = round(total, 2);
          this.form.total_movimientos = total;
          this.calcularTotales(true, true);
        }
        else {
          this.id = '';
          this.numero_documento = '';
          let total = 0;
          for (let i = 0; i < data.movimientos.length; i++) {
            let multiplicador = data.movimientos[i].tipo_movimiento.tipo === 'I'?1:-1;
            let valorPago = parseFloat(data.movimientos[i].saldo) * multiplicador;
            let valor = parseFloat(data.movimientos[i].valor) * multiplicador;
            this.form.movimientos.push({
              id: data.movimientos[i].id,
              descripcion_tipo_movimiento:
                data.movimientos[i].tipo_movimiento.descripcion,
              detalle: data.movimientos[i].detalle,
              fecha: data.movimientos[i].fecha,
              valor: valor,
              nombre_dia: data.movimientos[i].descripcion_dia,
              saldo: round(parseFloat(data.movimientos[i].saldo), 2),
              valor_pago: valorPago
            });
            total+= valorPago;
          }
          total = round(total, 2);
          this.form.total_movimientos = total;
          this.calcularTotales();
        }
        this.consultaRealizada = true;
      }).catch((error) => {
        // console.log(error)
        swal('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    cerrar: function () {
      let liqRecibir = parseFloat(this.form.liquido_recibir);
      if (isNaN(liqRecibir))
        liqRecibir = 0;
      if (liqRecibir == 0) {
        swal('El valor líquido a recibir debe ser mayor a cero.', 'Aviso', 'warning');
        return;
      }
      if (this.form.porcentaje_recaudador === '') {
        swal('Debe seleccionar un porcentaje para el cálculo del pago.', 'Aviso', 'warning');
        return;
      }
      else if (this.form.porcentaje_recaudador == 0) {
        if (this.form.movimientos.length === 0) {
           swal('Debe seleccionar al menos un movimiento.', 'Aviso', 'warning');
          return;
        }
      }
      swal({
        title: "Confirmación",
        text: "¿Desea guardar la liquidación del recaudador seleccionado?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + 'rol-recaudador';
          if (this.id !== '') {
            urlRequest += '/' + this.id;
            this.form._method = 'PUT';
          }
          else 
            this.form._method = undefined;
          axios.post(urlRequest, this.form).then(({data}) => {
            this.id = data.id;
            this.numero_documento = data.numero_documento;
            swal('El rol fue guardado exitósamente.', 'Realizado', 'success');
          })
          .catch(() => {
            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
          });
        }
      });
    },
    imprimirPdf: function () {
      window.open(url + '/rol-recaudador/' + this.id + '/pdf', '_blank');
    },
    imprimirExcel: function () {
      window.open(url + '/rol-recaudador/' + this.id + '/excel', '_blank');
    },
    cancelar: function () {
      this.consultaRealizada = false;
      this.registros.splice(0, this.registros.length);
      this.tarjetas.splice(0, this.tarjetas.length);
      this.form.movimientos.splice(0, this.form.movimientos.length);
    },
    cerrarMovimientos: function () {
      this.$modal.hide("tableSelectMov");
    },
  },
  data: function () {
    return {
      deuda_recaudador: 0,
      selectedBodega: null,
      porcentaje: porcentaje,
      int: int,
      consultaRealizada: false,
      searchMovimientos: "",
      url: url,
      selectedRecaudador: null,
      descripcion_ruta: "",
      id: '',
      numero_documento: '',
      form: {
        bodega_id: '',
        valor_supervision: '',
        tipo_supervision: 'U',
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        recaudador_id: "",
        movimientos: [],
        inicial_tarjetas: 0,
        tarjetas_activas: 0,
        tarjetas_nuevas: 0,
        valor_recaudado: 0,
        tarjetas_supervisadas: 0,
        devoluciones_completas: 0,
        total_activas: 0,
        tarjetas_cobradas: 0,
        tarjetas_no_cobradas: 0,
        porcentaje_cobro: 0,
        valor_pago: 0,
        total_movimientos: 0,
        liquido_recibir: 0,
        porcentaje_recaudador: "",
        _method: undefined
      },
      recaudadores: [],
      moneyFormat: moneyFormat,
      lodash: _,
      porcentajesTarjeta: this.porc_tarjetas.split(","),
      registros: [],
      tarjetas: []
    };
  },
  mounted: function () {
    if (this.bodegas.length == 1) {
      this.selectedBodega = this,bodegas[0];
      this.inputSucursal();
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/RolRecaudador.vue